import isValidAnswer from '@opsbase/lib-form/helpers/isValidAnswer';
import { flagColor } from '@opsbase/lib-issue/Flag';
import Palette from '@opsbase/lib-palette';
import StarIcon from '@opsbase/web-icons/icons/StarIcon';
import Horizontal from '@opsbase/web-layout/Horizontal';
import range from 'lodash/range';
import React, { useContext } from 'react';
import DetailsReportSwab from '../DetailsReportSwab';
import DetailsOpReportAnswerCell from './DetailsOpReportAnswerCell';
import { DetailsOpReportQuestionContext } from './DetailsOpReportQuestion';
export function DetailsOpReportAnswerRating() {
    const { a, q, r } = useContext(DetailsOpReportQuestionContext);
    const right = false;
    // If answered
    if (isValidAnswer(a, q, r)) {
        const v = a.value;
        const vn = parseInt(v.match(/\d+/)[0]);
        const color = flagColor(a.flag);
        return (React.createElement(DetailsOpReportAnswerCell, { right: right },
            React.createElement(Horizontal, { justify: "flex-start", centered: true },
                React.createElement(DetailsReportSwab, { color: color }),
                range(5).map(i => (React.createElement(StarIcon, { key: i, size: 16, htmlColor: i <= vn ? Palette.BlackCoral.main : Palette.BackgroundGrey.main }))))));
    }
    // Otherwise
    else {
        return React.createElement(DetailsOpReportAnswerCell, { right: right }, "- - -");
    }
}
export default DetailsOpReportAnswerRating;
